import { motion } from 'framer-motion'
import styled from 'styled-components'

export const AnimatedLayoutStyles = styled(motion.div)`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
`
